export default __webpack_public_path__ + "static/media/hero.849649ae.png";